angular
  .module('fca-used')
  .component('premiumDetails', {
    bindings: {
      open: '='
    },
    templateUrl: 'app/premium-details/premium-details.html',
    controller: premiumDetailsController,
    controllerAs: 'premiumDetails'
  });

premiumDetailsController.$inject = ['CONFIG'];

function premiumDetailsController(CONFIG) {
  var premiumDetails = this;
  var i;
  premiumDetails.items = [];
  premiumDetails.notes = [];
  premiumDetails.topCta = 1;

  var market = CONFIG.market.id;
  var language = CONFIG.language.id;
  var brand = CONFIG.brand.name;

  if (market === 'be' && (language === 'fr' || language === 'nl') && (brand === 'Fiat' || brand === 'Jeep' || brand === 'Abarth' || brand === 'FiatProfessional' || brand === 'Alfa Romeo')) {
    premiumDetails.topCta = 0;
  }

  for (i = 0; i < CONFIG.premium.descriptionItems; i++) {
    premiumDetails.items.push({
      class: 'premium_section_class_' + i,
      title: 'premium_section_title_' + i,
      description: 'premium_section_description_' + i,
      open: false
    });
  }

  for (i = 0; i < CONFIG.premium.descriptionNotes; i++) {
    premiumDetails.notes.push('premium_note_' + i);
  }

  premiumDetails.openExtendedWarrantyModal = function () {
    angular.element(document).find('html').css('position', 'fixed');
    angular.element(document).find('body').css('position', 'fixed');
    premiumDetails.showExtendedWarrantyModal = true;
  };

  premiumDetails.closeExtendedWarrantyModal = function () {
    angular.element(document).find('html').css('position', 'static');
    angular.element(document).find('body').css('position', 'static');
    premiumDetails.showExtendedWarrantyModal = false;
  };
}
